// @flow strict
import * as React from 'react'

import styles from './Card.module.scss'

export type Props = {
  children: string,
  as:
    | React.Element<'h1'>
    | React.Element<'h2'>
    | React.Element<'h3'>
    | React.Element<'h4'>,
}

export default ({ as, children }: Props) =>
  React.cloneElement(
    as,
    {
      className: styles.heading,
    },
    children,
  )
